/**
 * @license
 * Copyright 2019 JBoss Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {Injectable} from "@angular/core";
import {ApiEditorComponentFeatures} from "../_models/features.model";

/**
 * A service providing document related functionality, including the ability to
 * easily access the current document being edited and document related notifications
 * such as when it is changed.
 */
@Injectable()
export class FeaturesService {

    private features: ApiEditorComponentFeatures;

    constructor() {
        this.features = new ApiEditorComponentFeatures();
    }

    public setFeatures(features: ApiEditorComponentFeatures): void {
        this.features = features;
    }

    public getFeatures(): ApiEditorComponentFeatures {
        return this.features;
    }

}
